import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { watch } from 'vue'

import { useInstagramScenarioEditorStore } from '@/client/features/instagram_instantwin_prize/hooks/instagramScenarioEditorStore'
// Store

export default /*#__PURE__*/_defineComponent({
  __name: 'StepFollowCheck',
  setup(__props) {

const store = useInstagramScenarioEditorStore()
const { followCheck, errors, campaignRunning } = storeToRefs(store)

// フォローチェックの変更を監視してリアルタイムバリデーション
watch(
  followCheck,
  newValue => {
    // フォローチェック「なし」の場合はエラーをクリア
    if (!newValue.enabled) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [1]: _, ...rest } = store.errors
      store.errors = rest
      return
    }

    // フォローチェック「あり」の場合はバリデーション実行
    store.validateStep1()
  },
  { deep: true }
)

return { __sfc: true,store, followCheck, errors, campaignRunning }
}

})